<div style="margin-top: 0px; margin-left: 0px;">

  @if (create) {
    <div>
      <!-- Group search -->
      <div style="margin-top: 20px; margin-bottom: 10px;">
        <button type="button" pButton icon="fa fa-search search-icon" [label]="searchButtonLabel"
        (click)="searchForGroups()" [disabled]="!enableSearch"></button>
        <input type="text" name="searchtext" pInputText size="40" placeholder="Search word (ending * is treated as wildcard)"
          style="width:auto; margin-left: 5px;" [(ngModel)]="searchValue">
          <label for="domain" style="margin-left: 10px;">Domain Name:</label>
          <select name="domain" style="padding: 3.75px; margin-left: 5px;" [(ngModel)]="domain">
            @for (d of domains; track d) {
              <option value="{{d}}"
                [attr.selected]="(d == domain) ? '' : null">
                {{d}}
              </option>
            }
          </select>
        </div>
        <!-- Data table -->
        @if (hasDirGroups) {
          <p-table #dt class="dir-groups-table" [value]="dirGroups" [resizableColumns]="true"
            [scrollable]="true" scrollHeight="calc(170px)"
            selectionMode="single" [(selection)]="dirGroupSelection"
            (onRowSelect)="onRowSelect()" (onRowUnselect)="onRowUnselect()">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 40%;" pResizableColumn pSortableColumn="Name">
                  Group Name
                  <p-sortIcon field="Name"></p-sortIcon>
                </th>
                <th style="width: 60%;" pResizableColumn pSortableColumn="Description">
                  Group Description
                  <p-sortIcon field="Description"></p-sortIcon>
                </th>
              </tr>
              <tr>
                <th>
                  <input pInputText type="text" (input)="dt.filter($event.target.value, 'Name', 'contains')"
                    style="width: 100%;">
                  </th>
                  <th>
                    <input pInputText type="text" (input)="dt.filter($event.target.value, 'Description', 'contains')"
                      style="width: 100%;">
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                  <tr [pSelectableRow]="rowData">
                    <td style="width: 40%;">
                      <span class="uv-table-value">{{rowData.Name}}</span>
                    </td>
                    <td style="width: 60%;">
                      <span class="uv-table-value">{{rowData.Description}}</span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            }
            @if (dirGroups.length == 0) {
              <p style="height: 160px; text-align: center; font-size: 24px; margin-top: 10px;">
                {{searchEmptyResultMessage}}
              </p>
            }
          </div>
        }

        @if (!create) {
          <div style="text-align: center;">
            <button type="button" pButton icon="fa fa-refresh" [label]="syncGroupButtonLabel"
            (click)="syncGroup()"></button>
          </div>
        }

        <hr style="margin-top: 10px; margin-bottom: 10px;" />

        <form [formGroup]="form">
          <div class="mb-3 row" [ngClass]="{'has-error':!groupname.valid}">
            <span class="col-lg-2">Group Name:</span>
            <div class="col-lg-5">
              <input class="form-control" type="text" [formControl]="groupname" readonly />
            </div>
            @if (groupname.hasError('required')) {
              <div class="col-lg-3 alert alert-danger"
                style="padding: 5px; margin-bottom: 0px;">
                Group Name is required
              </div>
            }
          </div>
          <div class="mb-3 row" [ngClass]="{'has-error':!description.valid}">
            <span class="col-lg-2">Description:</span>
            <div class="col-lg-9">
              <input class="form-control" type="text" [formControl]="description" />
            </div>
          </div>
          <div class="mb-3 row" [ngClass]="{'has-error':!groupClass.valid}">
            <span class="col-lg-2">Group Type:</span>
            <div class="col-lg-3">
              <select class="form-control" [formControl]="groupClass">
                <option value="Administrator">Administrator</option>
                <option value="Regular">Regular</option>
                <option value="Observer">Observer</option>
              </select>
            </div>
            <user-type-info class="col-lg-1"></user-type-info>
          </div>
          <div class="mb-3 row" [ngClass]="{'has-error':!active.valid}">
            <div class="col-lg-2">
              <input type="checkbox" [formControl]="active" />
              <span class="uv-checkbox-label">Active</span>
            </div>
            <div class="col-lg-4">
              <input type="checkbox" [formControl]="enableUserAutoProvisioning" />
              <span class="uv-checkbox-label">Enable User Auto-Provisioning</span>
            </div>
            <div class="col-lg-4">
              <input type="checkbox" [formControl]="allowSamlSingleSignOn" />
              <span class="uv-checkbox-label">Allow SAML Single Sign-On</span>
            </div>
          </div>

          <hr />

          <div style="height: 40px;">
            <span class="label-text" style="display: inline-block; margin-left: calc(50% - 56px); padding-top: 5px;">Group Members</span>
            <button pButton icon="fa fa-plus-square-o" style="float: right;" [disabled]="!enableAddMemberUsers"
              label="Add Users" title="Add users to this group" class="add-button"
            (click)="addMemberUsers()"></button>
          </div>

          @if (hasMemberEntries) {
            <div style="padding-bottom: 10px;">
              <p-table #dt class="dir-group-users-table" [value]="entries" [resizableColumns]="true"
                [scrollable]="true" scrollHeight="calc(170px)">
                <ng-template pTemplate="header">
                  <tr>
                    <th pResizableColumn pSortableColumn="username">
                      Username
                      <p-sortIcon field="username"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="firstname">
                      First Name
                      <p-sortIcon field="firstname"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="lastname">
                      Last Name
                      <p-sortIcon field="lastname"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="class">
                      Class
                      <p-sortIcon field="class"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="type">
                      Type
                      <p-sortIcon field="type"></p-sortIcon>
                    </th>
                    <th pResizableColumn pSortableColumn="active">
                      Active
                      <p-sortIcon field="active"></p-sortIcon>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <input pInputText type="text" (input)="dt.filter($event.target.value, 'username', 'contains')"
                        style="width: 100%;">
                      </th>
                      <th>
                        <input pInputText type="text" (input)="dt.filter($event.target.value, 'firstname', 'contains')"
                          style="width: 100%;">
                        </th>
                        <th>
                          <input pInputText type="text" (input)="dt.filter($event.target.value, 'lastname', 'contains')"
                            style="width: 100%;">
                          </th>
                          <th>
                            <input pInputText type="text" (input)="dt.filter($event.target.value, 'class', 'contains')"
                              style="width: 100%;">
                            </th>
                            <th>
                              <input pInputText type="text" (input)="dt.filter($event.target.value, 'type', 'contains')"
                                style="width: 100%;">
                              </th>
                              <th>
                                <input pInputText type="text" (input)="dt.filter($event.target.value, 'active', 'contains')"
                                  style="width: 100%;">
                                </th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData>
                              <tr [pSelectableRow]="rowData">
                                <td >
                                  <span class="uv-table-value">{{rowData.username}}</span>
                                </td>
                                <td >
                                  <span class="uv-table-value">{{rowData.firstname}}</span>
                                </td>
                                <td >
                                  <span class="uv-table-value">{{rowData.lastname}}</span>
                                </td>
                                <td >
                                  <span class="uv-table-value">{{rowData.class}}</span>
                                </td>
                                <td >
                                  <span class="uv-table-value">{{rowData.type}}</span>
                                </td>
                                <td >
                                  <span class="uv-table-value">{{rowData.active}}</span>
                                </td>
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      }

                      @if (!hasMemberEntries) {
                        <div class="message-text">
                          No members have been added
                        </div>
                      }
                    </form>

                    <directory-user-dialog [(visible)]="dirUserDialogVisible" [target]="dirUserDialogTarget" [domains]="dirUserDialogDomains"
                      [dirUsers]="dirUserDialogUsers" [create]="true" [userType]="groupType" [allowSearch]="false"
                      (onOk)="onDirUserDialogOkClicked($event)" (onCancel)="onDirUserDialogCancelClicked()">
                    </directory-user-dialog>

                  </div>
